import React, { useEffect } from "react";
import { Menu } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";

const PillNavbar = () => {
  const [activeLink, setActiveLink] = useState(
    localStorage.getItem("activePillLink") || "services"
  );
  const handleLinkClick = (key) => {
    localStorage.setItem("activePillLink", key);
    setActiveLink(key);
  };
  useEffect(() => {
    if (window.location.pathname.includes("personal")) {
      setActiveLink("personal");
    } else {
      const savedActiveLink = localStorage.getItem("activePillLink");
      if (savedActiveLink && savedActiveLink !== activeLink) {
        setActiveLink(savedActiveLink);
      }
    }

    return () => {
      localStorage.setItem("activePillLink", "services");
    };
  }, []);
  return (
    <>
      <Menu
        mode="horizontal"
        className="w-full  h-5.4 m-0 rounded-sm bg-inputFieldGrey justify-between flex  items-center"
      >
        <div className="flex items-center">
          <Menu.Item
            key="services"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "services"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("services")}
          >
            <Link to="/main/settings">Services</Link>
          </Menu.Item>
        </div>
        <div className="flex items-center">
          <Menu.Item
            key="sub-services"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "sub-services"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("sub-services")}
          >
            <Link to="/main/settings/sub-services">Sub-Services</Link>
          </Menu.Item>
        </div>
        <div className="mr-1 rounded-sm hover:bg-white ">
          <Menu.Item
            key="personal"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "personal"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("personal")}
          >
            <Link to="/main/settings/personal/settings">Personal Settings</Link>
          </Menu.Item>
        </div>
        <div className="mr-1 rounded-sm hover:bg-white ">
          <Menu.Item
            key="Privacy"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "privacy"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("privacy")}
          >
            <Link to="/main/settings/privacy">Privacy</Link>
          </Menu.Item>
        </div>
        <div className="rounded-sm hover:bg-white ">
          <Menu.Item
            key="notifications"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "notifications"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("notifications")}
          >
            <Link to="/main/settings/notifications">Notifications</Link>
          </Menu.Item>
        </div>
        <div className="mr-1 rounded-sm hover:bg-white ">
          <Menu.Item
            key="delete"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "delete"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("delete")}
          >
            <Link to="/main/settings/delete">Delete Account</Link>
          </Menu.Item>
        </div>
        <div className="rounded-sm hover:bg-white ">
          <Menu.Item
            key="terms"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "terms"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("terms")}
          >
            <Link to="/main/settings/termsandconditions">
              Terms And Conditions
            </Link>
          </Menu.Item>
        </div>
        <div className="rounded-sm hover:bg-white ">
          <Menu.Item
            key="privacypolicy"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "privacypolicy"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("privacypolicy")}
          >
            <Link to="/main/settings/privacypolicy">Privacy Policy</Link>
          </Menu.Item>
        </div>
        <div className="rounded-sm hover:bg-white ">
          <Menu.Item
            key="messaging"
            className={`mr-1 rounded-sm hover:bg-white ${
              activeLink === "messaging"
                ? "!bg-white !text-black"
                : "!text-grey !bg-inputFieldGrey"
            } `}
            onClick={() => handleLinkClick("messaging")}
          >
            <Link to="/main/settings/messaging">Messaging</Link>
          </Menu.Item>
        </div>
      </Menu>
    </>
  );
};

export default PillNavbar;
